import { render } from "./Assinaturas.vue?vue&type=template&id=6fd268f1&scoped=true"
import script from "./Assinaturas.vue?vue&type=script&lang=js"
export * from "./Assinaturas.vue?vue&type=script&lang=js"

import "./Assinaturas.vue?vue&type=style&index=0&id=6fd268f1&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd268f1"]])

export default __exports__